module.exports = __webpack_public_path__ + "static/media/battery-power-charge-svgrepo-com.96c921dc.svg";